import {CtModelRouteData} from "@ctsolution/ct-framework";

export const FeeRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("fee");
